import React, { useEffect, useState } from "react";
import { fetchProducts } from "../../lib/api";
import { ProductCard } from "../ProductCard";

export const BestSellers = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    fetchProducts({ badge: "bestseller", limit: 8 }).then(setProducts).catch(() => {});
  }, []);

  return (
    <section className="pt-10 sm:pt-14 pb-6 sm:pb-8 bg-surface/60" data-testid="bestsellers-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex items-end justify-between gap-6">
          <div>
            <p className="uppercase tracking-[0.25em] text-xs font-semibold text-gold">Handpicked favourites from our collection</p>
            <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl tracking-tight font-medium text-charcoal mt-3">Best Selling Ilkal Sarees</h2>
          </div>
          <a href="/shop?badge=bestseller" data-testid="bestsellers-viewall-link" className="hidden sm:block text-xs tracking-[0.18em] uppercase text-maroon underline underline-offset-8 hover:text-maroon-dark whitespace-nowrap">
            View All
          </a>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mt-7">
          {products.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      </div>
    </section>
  );
};
